// @generated by protoc-gen-connect-es v1.4.0 with parameter "target=ts"
// @generated from file gitpod/v1/billing.proto (package gitpod.v1, syntax proto3)
/* eslint-disable */
// @ts-nocheck

import { CancelSubscriptionRequest, CancelSubscriptionResponse, ClearTopupFailureRequest, ClearTopupFailureResponse, CompleteBillingSetupRequest, CompleteBillingSetupResponse, CreateCardVerificationRequest, CreateCardVerificationResponse, CreateCouponRequest, CreateCouponResponse, CreateSubscriptionRequest, CreateSubscriptionResponse, GetAutoTopupSettingsRequest, GetAutoTopupSettingsResponse, GetBillingInfoRequest, GetBillingInfoResponse, GetBillingRecordRequest, GetBillingRecordResponse, GetCouponRequest, GetCouponResponse, GetCreditConsumptionTimeSeriesRequest, GetCreditConsumptionTimeSeriesResponse, GetStripePortalUrlRequest, GetStripePortalUrlResponse, GetStripePublishableKeyRequest, GetStripePublishableKeyResponse, GrantCreditsRequest, GrantCreditsResponse, ListCouponsRequest, ListCouponsResponse, ListSubscriptionsRequest, ListSubscriptionsResponse, ReconcileBillingRequest, ReconcileBillingResponse, SetBillingAddressRequest, SetBillingAddressResponse, SetBillingRealmRequest, SetBillingRealmResponse, SetTaxIDRequest, SetTaxIDResponse, SetupBillingRequest, SetupBillingResponse, SetupEnterpriseBillingRequest, SetupEnterpriseBillingResponse, UpdateAutoTopupSettingsRequest, UpdateAutoTopupSettingsResponse, UpdateBillingRecordRequest, UpdateBillingRecordResponse } from "./billing_pb.js";
import { MethodIdempotency, MethodKind } from "@bufbuild/protobuf";

/**
 * BillingService provides billing and subscription management functionality.
 *
 * @generated from service gitpod.v1.BillingService
 */
export const BillingService = {
  typeName: "gitpod.v1.BillingService",
  methods: {
    /**
     * @generated from rpc gitpod.v1.BillingService.SetupBilling
     */
    setupBilling: {
      name: "SetupBilling",
      I: SetupBillingRequest,
      O: SetupBillingResponse,
      kind: MethodKind.Unary,
    },
    /**
     * Completes the billing setup process after Stripe payment workflow completion.
     *
     * Use this method to:
     * - Verify Stripe setup intent completion
     * - Create Metronome contract for the organization
     * - Grant free trial credits
     * - Finalize billing configuration
     *
     * ### Examples
     *
     * - Complete billing setup:
     *
     *   Finalizes billing after successful Stripe payment setup.
     *
     *   ```yaml
     *   organizationId: "b0e12f6c-4c67-429d-a4a6-d9838b5da047"
     *   setupIntentId: "seti_1234567890abcdef"
     *   ```
     *
     * @generated from rpc gitpod.v1.BillingService.CompleteBillingSetup
     */
    completeBillingSetup: {
      name: "CompleteBillingSetup",
      I: CompleteBillingSetupRequest,
      O: CompleteBillingSetupResponse,
      kind: MethodKind.Unary,
    },
    /**
     * Retrieves billing information including credit balance for an organization.
     *
     * Use this method to:
     * - Check available credits for the organization
     * - Monitor credit usage and remaining balance
     * - Display billing status in the dashboard
     * - Implement usage-based alerts
     *
     * ### Examples
     *
     * - Get billing info:
     *
     *   Retrieves current credit balance and usage information.
     *
     *   ```yaml
     *   organizationId: "b0e12f6c-4c67-429d-a4a6-d9838b5da047"
     *   ```
     *
     * @generated from rpc gitpod.v1.BillingService.GetBillingInfo
     */
    getBillingInfo: {
      name: "GetBillingInfo",
      I: GetBillingInfoRequest,
      O: GetBillingInfoResponse,
      kind: MethodKind.Unary,
    },
    /**
     * Reconciles billing state for an organization.
     *
     * Use this method to:
     * - Ensure billing state is up-to-date with external providers (Stripe, Metronome)
     * - Sync organization tier based on active contracts
     * - Update credit status and payment failure state
     *
     * Call this when the user navigates to the billing page to ensure
     * they see the most current billing information.
     *
     * ### Examples
     *
     * - Reconcile billing:
     *
     *   Triggers billing reconciliation for the organization.
     *
     *   ```yaml
     *   organizationId: "b0e12f6c-4c67-429d-a4a6-d9838b5da047"
     *   ```
     *
     * @generated from rpc gitpod.v1.BillingService.ReconcileBilling
     */
    reconcileBilling: {
      name: "ReconcileBilling",
      I: ReconcileBillingRequest,
      O: ReconcileBillingResponse,
      kind: MethodKind.Unary,
    },
    /**
     * Creates a new subscription for an organization.
     *
     * Use this method to:
     * - Create a new subscription with specified type
     * - Add subscription to existing Metronome contract
     * - Create new contract if none exists
     *
     * @generated from rpc gitpod.v1.BillingService.CreateSubscription
     */
    createSubscription: {
      name: "CreateSubscription",
      I: CreateSubscriptionRequest,
      O: CreateSubscriptionResponse,
      kind: MethodKind.Unary,
    },
    /**
     * Cancels an existing subscription.
     *
     * Use this method to:
     * - Cancel active subscription
     * - Stop recurring billing
     * - Maintain access until end of billing period
     *
     * ### Examples
     *
     * - Cancel subscription:
     *
     *   Cancels the specified subscription.
     *
     *   ```yaml
     *   organizationId: "b0e12f6c-4c67-429d-a4a6-d9838b5da047"
     *   subscriptionType: SUBSCRIPTION_TYPE_CORE
     *   ```
     *
     * @generated from rpc gitpod.v1.BillingService.CancelSubscription
     */
    cancelSubscription: {
      name: "CancelSubscription",
      I: CancelSubscriptionRequest,
      O: CancelSubscriptionResponse,
      kind: MethodKind.Unary,
    },
    /**
     * Lists current subscriptions for an organization.
     *
     * Use this method to:
     * - View all active subscriptions
     * - Check subscription status and details
     * - Monitor subscription lifecycle
     *
     * ### Examples
     *
     * - List subscriptions:
     *
     *   Retrieves all subscriptions for the organization.
     *
     *   ```yaml
     *   organizationId: "b0e12f6c-4c67-429d-a4a6-d9838b5da047"
     *   ```
     *
     * @generated from rpc gitpod.v1.BillingService.ListSubscriptions
     */
    listSubscriptions: {
      name: "ListSubscriptions",
      I: ListSubscriptionsRequest,
      O: ListSubscriptionsResponse,
      kind: MethodKind.Unary,
    },
    /**
     * Grants additional credits to an organization.
     *
     * Use this method to:
     * - Grant credits to existing customers
     * - Add promotional credits
     * - Provide customer service credits
     *
     * ### Examples
     *
     * - Grant credits:
     *
     *   Grants 80 credits to the organization for one year.
     *
     *   ```yaml
     *   organizationId: "b0e12f6c-4c67-429d-a4a6-d9838b5da047"
     *   creditsAmount: 80.0
     *   ```
     *
     * @generated from rpc gitpod.v1.BillingService.GrantCredits
     */
    grantCredits: {
      name: "GrantCredits",
      I: GrantCreditsRequest,
      O: GrantCreditsResponse,
      kind: MethodKind.Unary,
    },
    /**
     * Retrieves the Stripe publishable key for an organization.
     *
     * Use this method to:
     * - Get the appropriate Stripe publishable key for frontend payment forms
     * - Support different billing realms (production/sandbox)
     * - Ensure proper isolation between organizations
     *
     * ### Examples
     *
     * - Get publishable key:
     *
     *   Retrieves the Stripe publishable key for the organization.
     *
     *   ```yaml
     *   organizationId: "b0e12f6c-4c67-429d-a4a6-d9838b5da047"
     *   ```
     *
     * @generated from rpc gitpod.v1.BillingService.GetStripePublishableKey
     */
    getStripePublishableKey: {
      name: "GetStripePublishableKey",
      I: GetStripePublishableKeyRequest,
      O: GetStripePublishableKeyResponse,
      kind: MethodKind.Unary,
    },
    /**
     * Sets the billing realm for an organization.
     *
     * Use this method to:
     * - Change organization's billing realm between sandbox and production
     * - Configure billing environment for the organization
     * - Requires Account permissions to perform the operation
     *
     * ### Examples
     *
     * - Set billing realm:
     *
     *   Changes organization billing realm to production.
     *
     *   ```yaml
     *   organizationId: "b0e12f6c-4c67-429d-a4a6-d9838b5da047"
     *   realm: BILLING_REALM_PRODUCTION
     *   ```
     *
     * @generated from rpc gitpod.v1.BillingService.SetBillingRealm
     */
    setBillingRealm: {
      name: "SetBillingRealm",
      I: SetBillingRealmRequest,
      O: SetBillingRealmResponse,
      kind: MethodKind.Unary,
    },
    /**
     * Creates a card verification entry for an account, allowing them to skip credit card verification.
     *
     * Use this method to:
     * - Grant Ona for Open Source program participants immediate access
     * - Mark pre-vetted accounts as credit card verified
     *
     * Requires the 'create_card_verification' account permission.
     *
     * ### Examples
     *
     * - Create card verification for open source maintainer:
     *
     *   ```yaml
     *   email: "maintainer@example.org"
     *   ```
     *
     * @generated from rpc gitpod.v1.BillingService.CreateCardVerification
     */
    createCardVerification: {
      name: "CreateCardVerification",
      I: CreateCardVerificationRequest,
      O: CreateCardVerificationResponse,
      kind: MethodKind.Unary,
    },
    /**
     * Sets or updates the tax ID for an organization.
     *
     * Use this method to:
     * - Set tax ID for billing purposes
     * - Update existing tax ID information
     * - Support various tax ID types (VAT, GST, etc.)
     *
     * ### Examples
     *
     * - Set EU VAT ID:
     *
     *   Sets a VAT ID for an EU organization.
     *
     *   ```yaml
     *   organizationId: "b0e12f6c-4c67-429d-a4a6-d9838b5da047"
     *   taxIdType: "eu_vat"
     *   taxIdValue: "DE123456789"
     *   ```
     *
     * @generated from rpc gitpod.v1.BillingService.SetTaxID
     */
    setTaxID: {
      name: "SetTaxID",
      I: SetTaxIDRequest,
      O: SetTaxIDResponse,
      kind: MethodKind.Unary,
    },
    /**
     * Gets details about a specific billing record.
     *
     * @generated from rpc gitpod.v1.BillingService.GetBillingRecord
     */
    getBillingRecord: {
      name: "GetBillingRecord",
      I: GetBillingRecordRequest,
      O: GetBillingRecordResponse,
      kind: MethodKind.Unary,
      idempotency: MethodIdempotency.NoSideEffects,
    },
    /**
     * Updates a billing record
     *
     * @generated from rpc gitpod.v1.BillingService.UpdateBillingRecord
     */
    updateBillingRecord: {
      name: "UpdateBillingRecord",
      I: UpdateBillingRecordRequest,
      O: UpdateBillingRecordResponse,
      kind: MethodKind.Unary,
    },
    /**
     * Creates a new coupon for support staff to distribute to customers.
     *
     * Use this method to:
     * - Create promotional coupons for marketing campaigns
     * - Generate support coupons for customer service
     * - Set up trial credit coupons for new users
     *
     * @generated from rpc gitpod.v1.BillingService.CreateCoupon
     */
    createCoupon: {
      name: "CreateCoupon",
      I: CreateCouponRequest,
      O: CreateCouponResponse,
      kind: MethodKind.Unary,
    },
    /**
     * Lists existing coupons with filtering and pagination support.
     *
     * Use this method to:
     * - View all created coupons
     * - Filter coupons by status or type
     * - Monitor coupon usage and expiration
     *
     * @generated from rpc gitpod.v1.BillingService.ListCoupons
     */
    listCoupons: {
      name: "ListCoupons",
      I: ListCouponsRequest,
      O: ListCouponsResponse,
      kind: MethodKind.Unary,
      idempotency: MethodIdempotency.NoSideEffects,
    },
    /**
     * Retrieves a specific coupon by its code.
     *
     * Use this method to:
     * - Validate coupon codes during checkout
     * - Display coupon details to users
     * - Check coupon availability and expiration
     *
     * ### Examples
     *
     * - Get coupon by code:
     *
     *   Retrieves coupon details for validation.
     *
     *   ```yaml
     *   couponCode: "WELCOME2024"
     *   organizationId: "123e4567-e89b-12d3-a456-426614174000"
     *   ```
     *
     * @generated from rpc gitpod.v1.BillingService.GetCoupon
     */
    getCoupon: {
      name: "GetCoupon",
      I: GetCouponRequest,
      O: GetCouponResponse,
      kind: MethodKind.Unary,
      idempotency: MethodIdempotency.NoSideEffects,
    },
    /**
     * Sets or updates the billing address for an organization.
     *
     * Use this method to:
     * - Set billing address for tax calculation and compliance
     * - Update existing billing address information
     * - Support international billing requirements
     *
     * ### Examples
     *
     * - Set billing address:
     *
     *   Sets a complete billing address for the organization.
     *
     *   ```yaml
     *   organizationId: "b0e12f6c-4c67-429d-a4a6-d9838b5da047"
     *   name: "John Doe"
     *   address:
     *     line1: "123 Main St"
     *     line2: "Suite 100"
     *     city: "San Francisco"
     *     state: "CA"
     *     postalCode: "94105"
     *     country: "US"
     *   ```
     *
     * @generated from rpc gitpod.v1.BillingService.SetBillingAddress
     */
    setBillingAddress: {
      name: "SetBillingAddress",
      I: SetBillingAddressRequest,
      O: SetBillingAddressResponse,
      kind: MethodKind.Unary,
    },
    /**
     * Retrieves the Stripe Customer Portal URL for an organization.
     *
     * Use this method to:
     * - Get the Stripe Customer Portal URL for billing management
     * - Allow customers to manage their payment methods and billing details
     * - Provide access to billing history and invoices
     *
     * ### Examples
     *
     * - Get Stripe portal URL:
     *
     *   Retrieves the portal URL for the organization.
     *
     *   ```yaml
     *   organizationId: "b0e12f6c-4c67-429d-a4a6-d9838b5da047"
     *   ```
     *
     * @generated from rpc gitpod.v1.BillingService.GetStripePortalUrl
     */
    getStripePortalUrl: {
      name: "GetStripePortalUrl",
      I: GetStripePortalUrlRequest,
      O: GetStripePortalUrlResponse,
      kind: MethodKind.Unary,
      idempotency: MethodIdempotency.NoSideEffects,
    },
    /**
     * Clears a topup payment failure for an organization.
     *
     * Use this method to:
     * - Acknowledge and clear a failed topup payment
     * - Allow the UI to return to normal state after user acknowledges the failure
     *
     * Unlike subscription failures which auto-resolve when payment succeeds,
     * topup failures need explicit user acknowledgment because the commit was
     * voided by Metronome and the user needs to retry with a working payment method.
     *
     * @generated from rpc gitpod.v1.BillingService.ClearTopupFailure
     */
    clearTopupFailure: {
      name: "ClearTopupFailure",
      I: ClearTopupFailureRequest,
      O: ClearTopupFailureResponse,
      kind: MethodKind.Unary,
    },
    /**
     * Returns daily credit consumption (OCU) time series for an organization,
     * broken down by metric category.
     *
     * @generated from rpc gitpod.v1.BillingService.GetCreditConsumptionTimeSeries
     */
    getCreditConsumptionTimeSeries: {
      name: "GetCreditConsumptionTimeSeries",
      I: GetCreditConsumptionTimeSeriesRequest,
      O: GetCreditConsumptionTimeSeriesResponse,
      kind: MethodKind.Unary,
      idempotency: MethodIdempotency.NoSideEffects,
    },
    /**
     * Sets up enterprise billing for an organization.
     *
     * Creates a Stripe customer, subscribes to the enterprise pricing plan,
     * and updates the billing realm. Idempotent — safe to retry on failure.
     *
     * Requires the 'change_billing_realm' account permission.
     *
     * ### Examples
     *
     * - Setup enterprise billing (production):
     *
     *   ```yaml
     *   organizationId: "b0e12f6c-4c67-429d-a4a6-d9838b5da047"
     *   email: "billing@example.com"
     *   ```
     *
     * - Setup enterprise billing (sandbox):
     *
     *   ```yaml
     *   organizationId: "b0e12f6c-4c67-429d-a4a6-d9838b5da047"
     *   sandbox: true
     *   ```
     *
     * @generated from rpc gitpod.v1.BillingService.SetupEnterpriseBilling
     */
    setupEnterpriseBilling: {
      name: "SetupEnterpriseBilling",
      I: SetupEnterpriseBillingRequest,
      O: SetupEnterpriseBillingResponse,
      kind: MethodKind.Unary,
      idempotency: MethodIdempotency.Idempotent,
    },
    /**
     * Updates auto-topup settings for an organization.
     *
     * Use this method to:
     * - Enable or disable automatic credit top-ups
     * - Configure the top-up amount and threshold
     * - Set a daily safety cap on automatic top-ups
     *
     * Requires Core tier and the auto-topup feature flag.
     *
     * @generated from rpc gitpod.v1.BillingService.UpdateAutoTopupSettings
     */
    updateAutoTopupSettings: {
      name: "UpdateAutoTopupSettings",
      I: UpdateAutoTopupSettingsRequest,
      O: UpdateAutoTopupSettingsResponse,
      kind: MethodKind.Unary,
    },
    /**
     * Retrieves auto-topup settings for an organization.
     *
     * @generated from rpc gitpod.v1.BillingService.GetAutoTopupSettings
     */
    getAutoTopupSettings: {
      name: "GetAutoTopupSettings",
      I: GetAutoTopupSettingsRequest,
      O: GetAutoTopupSettingsResponse,
      kind: MethodKind.Unary,
      idempotency: MethodIdempotency.NoSideEffects,
    },
  }
} as const;

